import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/contexts/AuthContext";
import BrandName from "@/components/BrandName";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@callsheet.app");
  const [password, setPassword] = useState("CallSheet@2026");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="block mb-10 text-center" data-testid="login-brand">
          <BrandName variant="gold" size="lg" withClapper />
        </Link>
        <div className="cs-card rounded-2xl p-8 cs-grain relative">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#F5B82E] mb-3">Restricted Access</div>
          <h1 className="font-display text-3xl uppercase tracking-tight">Login to your Profile</h1>
          <p className="mt-2 text-sm text-white/60">Use your verified email and password.</p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <Label htmlFor="email" className="text-[10px] tracking-[0.25em] uppercase text-white/60">Email</Label>
              <Input
                id="email" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                required data-testid="login-email"
                className="mt-2 h-11 bg-black/40 border-white/15 focus:border-[color:var(--association-theme)]"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-[10px] tracking-[0.25em] uppercase text-white/60">Password</Label>
              <Input
                id="password" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                required data-testid="login-password"
                className="mt-2 h-11 bg-black/40 border-white/15 focus:border-[color:var(--association-theme)]"
              />
            </div>
            <Button
              type="submit" disabled={busy}
              className="btn-themed h-12 w-full rounded-full text-xs uppercase tracking-[0.25em] font-semibold"
              data-testid="login-submit"
            >
              {busy ? "Authenticating…" : "Authenticate →"}
            </Button>
          </form>

          <div className="mt-6 text-center text-xs text-white/60">
            New here?{" "}
            <Link to="/register" className="text-[#F5B82E] hover:underline" data-testid="goto-register">
              Verify Credentials
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
